module.exports = __webpack_public_path__ + "img/search.8346575f.svg";